import getters from './getters';
import mutations from './mutations';
import actions from './actions';
function initState() {
    return {
        originAgents: [],
        searchResults: [],
        info: {
            excludeAgentIds: '',
            useExternalUrl: false,
            totalAgentsCount: 0,
            customAgents: [],
            autoSort: false,
            pageSize: 24,
            pageNum: 1,
            showSearchInput: false,
            allTotal: 0
        }
    };
}

export default {
    namespaced: true,
    state: initState,
    getters,
    mutations,
    actions
};
